import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'
import icUserDefault from 'assets/images/ic-user-profile.svg'
import { Button, InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'
import Datepicker from 'components/commons/datepicker'
import RadioButton from 'components/commons/radio-button'
import icKey from 'assets/images/ic-key.svg'
import moment from 'moment'

export const UserCreate = ({ dataUser, onChangeForm, errorForm, onGenerate, isLoading, roleList, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-6 px-9 py-4'}>
            <TabToggle
                title={'Profile'}
                content={
                    <div className={'flex space-x-10 py-2 px-10 mb-2'}>
                        <div className={'justify-items-start space-y-3 basis-1/4'}>
                            <UploadImage
                                classNameImage={'!w-56 !h-56 border-4 border-blue-20 rounded-full'}
                                classNameButtonDelete={'!top-3 !right-2'}
                                id={'image-profile'}
                                value={dataUser?.profile_picture?.base64 || icUserDefault}
                                caption={'Foto Profile'}
                                onChange={(value) => onChangeForm({ name: 'profile_picture', value })}
                            />
                            <InlineError
                                className='mt-2 justify-self-center -ml-10'
                                message={errorForm?.profile_picture}
                            />
                        </div>
                        <div className={'flex flex-col space-y-6 basis-2/4'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Nama</div>
                                <Input
                                    className={'flex-1'}
                                    name={'name'}
                                    placeholder={'Masukkan nama'}
                                    maxLength={60}
                                    value={dataUser?.name}
                                    onChange={onChangeForm}
                                />
                                <InlineError className='mt-2' message={errorForm?.name} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Email</div>
                                <Input
                                    className={'flex-1'}
                                    name={'email'}
                                    placeholder={'Masukkan email'}
                                    value={dataUser?.email}
                                    onChange={onChangeForm}
                                />
                                <InlineError className='mt-2' message={errorForm?.email} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Tanggal Lahir</div>
                                <Datepicker
                                    value={dataUser?.birth_date}
                                    onChange={(value) => onChangeForm({ name: 'birth_date', value })}
                                    format={'YYYY-MM-DD'}
                                    maxDate={moment()}
                                    isClearable
                                />
                                <InlineError className='mt-2' message={errorForm?.birth_date} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>No. Telepon</div>
                                <Input
                                    type={'tel'}
                                    addonBefore={'+62'}
                                    className={'flex-1'}
                                    name={'phone_number'}
                                    placeholder={'Masukkan no. telepon'}
                                    maxLength={14}
                                    value={dataUser?.phone_number}
                                    onChange={onChangeForm}
                                />
                                <InlineError className='mt-2' message={errorForm?.phone_number} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Jenis Kelamin</div>
                                <div className={'flex space-x-2'}>
                                    <RadioButton
                                        label={'Perempuan'}
                                        name={'gender'}
                                        value={'female'}
                                        checked={dataUser?.gender === 'female'}
                                        onChange={onChangeForm}
                                    />
                                    <RadioButton
                                        label={'Laki-Laki'}
                                        name={'gender'}
                                        value={'male'}
                                        checked={dataUser?.gender === 'male'}
                                        onChange={onChangeForm}
                                    />
                                </div>
                                <InlineError className='mt-2' message={errorForm?.gender} />
                            </div>
                        </div>
                    </div>
                }
            />
            <TabToggle
                title={'Accessibility'}
                content={
                    <div className={'flex space-x-20 px-10 py-2 mb-2'}>
                        <div className={'flex flex-col space-y-3 w-1/2'}>
                            <div className={'font-semibold text-blue-90 required'}>Role</div>
                            <Select
                                name={'role'}
                                className={'flex-1'}
                                optionsClassName={'max-h-28'}
                                placeholder={'Pilih role'}
                                options={roleList}
                                value={dataUser?.role}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.role} />
                        </div>
                        <div className={'flex flex-col space-y-3 w-1/2'}>
                            <div className={'font-semibold text-blue-90 required'}>Password</div>
                            <div className={'flex space-x-3'}>
                                <Input
                                    className={'flex-1'}
                                    name={'password'}
                                    placeholder={'Masukkan Password'}
                                    type={'password'}
                                    value={dataUser?.password}
                                    onChange={onChangeForm}
                                />
                                <Button title={'Generate Password'} icon={icKey} onClick={onGenerate} />
                            </div>
                            <InlineError className='mt-2' message={errorForm?.password} />
                        </div>
                    </div>
                }
            />
            <div className={'px-6 py-3 flex justify-center'}>
                <Button className={'w-[200px]'} title={'Submit'} loading={isLoading} onClick={onSubmit} />
            </div>
        </div>
    )
}
